<template>
  <div class="pricegroups-wrapper mx-auto mt-5">
    <div v-for="pricegroup in sortedPricegroups"
         :key="`pr-${pricegroup.pricegroup_id}`">
      <select-pricegroup-tickets-amount :pricegroup="pricegroup"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "SelectTicketsPricegroups",
  mounted() {
    this.$store.commit('setStep', 2)
  },
  computed: {
    ...mapState(['pricegroups']),
    sortedPricegroups() {
      return Object.values(this.pricegroups).sort((a, b) => (b.pricegroup?.sort_order || 1) - (a.pricegroup?.sort_order || 1))
    }
  },
}
</script>
